let globalChecker;
const form = document.querySelector('.wpcf7-form');
const wpcf7Elm = document.querySelector('.wpcf7');

class FormValidation {
	checkFields(e, wrapper) {
		globalChecker = false;
		const checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');
		const hiddenInput = document.querySelectorAll('.hidden-field-item')[0];
		const errorM = wrapper.querySelectorAll('.custom-error-message')[0];
		const emailsArray = [];

		hiddenInput.value = '';
		errorM.classList.remove('error-active');

		for (let i = 0, len = checkboxes.length; i < len; i++) {
			if (checkboxes[i].checked) {
				globalChecker = true;
			}
		}

		if (globalChecker) {
			for (let i = 0, len = checkboxes.length; i < len; i++) {
				if (checkboxes[i].checked) {
					emailsArray.push(checkboxes[i].value);
				}
			}
			const arrayToString = emailsArray.toString();
			hiddenInput.value = arrayToString;
		} else {
			errorM.classList.add('error-active');
			wpcf7Elm.addEventListener('wpcf7submit', (e) => {
				e.preventDefault();
			});
		}
	}

	init() {
        const wrapper = document.getElementById('custom-checkboxes-field');
        if( wpcf7Elm && wrapper ){
            const submitBtn = wpcf7Elm.querySelector('input[type="submit"]');

            submitBtn.addEventListener('click', (e) => {
                this.checkFields(e, wrapper);
            });
        }
	}
}

export default new FormValidation();
